import React from 'react';
import Form from 'react-bootstrap/Form';

const BasicRecordingSettings = ({
  disabled,
  updateConfigHandler,
  maxMessageCount,
  maxMessagesPerSecondCount,
}: {
  disabled: boolean;
  updateConfigHandler: (key: string, value: any) => void;
  maxMessageCount: number;
  maxMessagesPerSecondCount: number;
}) => {
  return (
    <div>
      <div className={'mb-4'}>
        <label htmlFor="maxMessagesCount">Max Messages Count</label>
        <Form.Control
          id={'maxMessagesCount'}
          disabled={disabled}
          onChange={event => {
            updateConfigHandler('maxMessagesCount', event.target.value);
          }}
          type={'number'}
          min={0}
          placeholder={'Enter max messages count...'}
          defaultValue={maxMessageCount}
        />
      </div>

      <div>
        <label htmlFor="maxMessagesPerSecondCount">Max Messages per Second</label>
        <Form.Control
          id={'maxMessagesPerSecondCount'}
          disabled={disabled}
          onChange={event => {
            updateConfigHandler('maxMessagesPerSecondCount', event.target.value);
          }}
          type={'number'}
          min={0}
          placeholder={'Enter max messages per second...'}
          defaultValue={maxMessagesPerSecondCount}
        />
      </div>
    </div>
  );
};

export default BasicRecordingSettings;
